import { deleteNewsService } from "../infrastructure/services/deleteNewsService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const deleteNews = {
    async execute(title: string): Promise<void> {
        await deleteNewsService.execute(await tokenValidation.execute(), title);
    },
};

